<template>
<div style="height: 1400px;">
  <v-form v-model="formValid">
    <v-jsonschema-form v-if="schema" :schema="schema" :model="dataObject_edit" :options="options"

     />
     <v-btn @click="savegroup">submit</v-btn>
  </v-form>
  </div>
</template>

<script>
export default {
data () {
    return {
      schema: null,
      schema_tmp: {},
      dataObject_edit: {},
      formValid: false,
      options: {
        debug: true,
        disableAll: false,
        autoFoldObjects: false
      }
    }

  },
   mounted() {
         if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}

    this.$http
      .get(this.$root.apiUrl+'/api/v1/schemas/instances.json')
      .then(response => {
          this.schema_tmp = response.data;

        this.$http
            .get(this.schema_tmp.uri_api + this.$route.params.id)
            .then(response => {
                this.dataObject_edit = JSON.parse(JSON.stringify(response.data.result))  ;
                this.schema=this.schema_tmp;
                });
        }
      )},

    methods: {
  	savegroup: function() {
    if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}
      this.$http
      .put(this.schema_tmp.uri_api + this.$route.params.id, this.dataObject_edit)
      .then(r => {
            // console.log('r: ', JSON.stringify(r, null, 2))
            this.$router.push({ name: 'instances' })
            });
    }

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/instances/edit.vue